import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './NewbuildingPushToCallBanner.css';

export const NewbuildingPushToCallBanner = ({ children }: React.PropsWithChildren) => {
  return (
    <div className={style['container']} data-testid="NewbuildingPushToCallBanner">
      <div className={style['image']} />
      <div className={style['actions']}>
        <UIHeading1 textAlign="center">
          Если понравилась квартира, <br />
          позвоните застройщику
        </UIHeading1>
        <div data-testid="PushToCallButton">{children}</div>
      </div>
    </div>
  );
};
